import MainScript from './main.js'
import DesktopView from './desktop/desktop.vue';

// let service = new services();
export default {
    name: 'MManageItems',
    mixins: [MainScript],
    data () {
        return {}
    },
  
    components: {
        
        //
        'component-desktop':DesktopView
    },
  
    methods: {},
    created: function(){}
}


// WEBPACK FOOTER //
// ./src/pages/PlacedOrders/script.js